import { Bur } from 'generated/graphql';

export function isUnit(bur: Bur | null): boolean {
  if (!bur) return false;
  if (!bur.hasMerd) return false;
  if (!bur.name) return false;
  return true;
}
